import { isArray, get } from 'lodash';

export function toTitleCase(text) {
  if (text) {
    const loweredAndSplitted = text.trim().toLowerCase().split(' ');
    const titleCased = loweredAndSplitted.map((word) => (word[0].toUpperCase() + word.slice(1)));

    return titleCased.join(' ');
  }
}

export const sorting = (a, b) => (a === b ? 0 : a > b ? 1 : -1);

export const sortingLowerCase = (a, b, key) => {
  const alk = (String(key ? a[key] : a)).toLowerCase();
  const blk = (String(key ? b[key] : b)).toLowerCase();

  if (alk > blk) {
    return 1;
  }
  if (alk < blk) {
    return -1;
  }

  return 0;
};

export const showField = (config, path, name) => {
  const hide = get(config, `${path}.hide`);

  return !(isArray(hide) && hide.length > 0 && hide.includes(name));
};
